module.exports = __webpack_public_path__ + "img/ji1.4e8ee813.png";